const variantInputs = document.querySelectorAll("[js-product-variants]")
if(variantInputs){
  const formVariantInput = document.querySelector("[js-variant-id]")
  variantInputs.forEach((variantInput) => {
    variantInput.addEventListener("change", function(){
        const selectedVariant = document.querySelector("[js-product-variants]:checked")
        const selectedVariantId = selectedVariant.getAttribute("variant-id")
        formVariantInput.value = selectedVariantId
    })
})
}
